module.exports = __webpack_public_path__ + "img/5.f96ddaab.jpg";